<div class="no-shows-input" *ngIf="jobStatusService.updatedCustomerConfig">
  <p>
    Should students who are marked as "No Show" be included in metric
    calculations?
  </p>
  <mat-radio-group
    class="no-shows-radios"
    [(ngModel)]="
      jobStatusService.updatedCustomerConfig['enrollment.IncludeNoShow']
    "
  >
    <mat-radio-button [value]="'0'"
      >No, do not include them in my metrics</mat-radio-button
    >
    <mat-radio-button [value]="'1'"
      >Yes, include them in my metrics</mat-radio-button
    >
  </mat-radio-group>
</div>
